module.exports = __webpack_public_path__ + "static/media/receipt.4f06b384.svg";